import { createContext, useContext } from "react";

import type { AxiosInstances } from "../../features/axios-instances";

export type AxiosContextType = {
  orchestrator: AxiosInstances;
};

export const AxiosContext = createContext<AxiosContextType | null>(null);
export function useAxiosContext(): AxiosContextType {
  const context = useContext(AxiosContext);
  if (!context) {
    throw new Error("useAxiosContext must be used within an AxiosProvider");
  }
  return context;
}
